import React from "react";
import { Col, Row } from "react-bootstrap";

function Faq() {
    return(
        <>
            <Row>
                <Col xs={1} lg={2}></Col>
                <Col xs={10} lg={8}>
                    <div className="cl_cat_title">
                        <h1>Why Do We Offer a Multi-Cart Feature?</h1>
                    </div>
                </Col>
                <Col xs={1} lg={2}></Col>
            </Row>
            
            <Row>
                <Col xs={1} lg={2}></Col>
                <Col xs={10} lg={8}>
                    <p style={{textAlign : "justify", fontSize : "20px"}}>&emsp;&emsp;We provide the multi-cart feature for several valuable reasons:<br></br>
                    &emsp;&emsp;&emsp;&emsp;<b>Multiple Cart Options:</b> This feature allows you to create and manage multiple carts, enabling you to select and compare different sets of firecrackers from our service. Once you’ve reviewed your options, you can easily proceed with the cart that best suits your needs for checkout.<br></br>
                    &emsp;&emsp;&emsp;&emsp;<b>Cost-Sharing Advantage:</b> Our multi-cart feature also offers the benefit of sharing transportation costs. You can combine your orders with friends, relatives, or neighbours into a single shipment, helping you save on delivery fees while making group purchases more convenient.</p>
                </Col>
                <Col xs={1} lg={2}></Col>
            </Row>

            <Row>
                <Col xs={1} lg={2}></Col>
                <Col xs={10} lg={8}>
                    <div className="cl_cat_title">
                        <h1 className="category_title">Delivery Procedure</h1>
                    </div>
                </Col>
                <Col xs={1} lg={2}></Col>
            </Row>

            <Row>
                <Col xs={1} lg={2}></Col>
                <Col xs={10} lg={8} className="d-flex justify-content-center">
                    <iframe width="1207" height="679" src="https://www.youtube.com/embed/CCC2SkuJzeI" title="🚚 CrackleCart – Your Crackers, Delivered Safely! 🎆" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </Col>
                <Col xs={1} lg={2}></Col>
            </Row>

            <Row>
                <Col xs={1} lg={2}></Col>
                <Col xs={10} lg={8}>
                    <p style={{textAlign : "justify", fontSize : "20px", marginTop : "3%"}}>&emsp;&emsp;<b>🛒 How will I receive my crackers after placing an order?</b><br></br>
                    &emsp;&emsp;&emsp;&emsp;Your order will be packed safely and sent to the nearest <b>transport office</b> based on your delivery address. You’ll be notified when it’s ready for pickup.</p>
                </Col>
                <Col xs={1} lg={2}></Col>
            </Row>

            <Row>
                <Col xs={1} lg={2}></Col>
                <Col xs={10} lg={8}>
                    <p style={{textAlign : "justify", fontSize : "20px", marginTop : "3%"}}>&emsp;&emsp;<b>🧾 Is home delivery available?</b><br></br>
                    &emsp;&emsp;&emsp;&emsp;Currently, <b>we do not offer home delivery</b> due to government transportation regulations for fireworks. All deliveries are made only to the <b>nearest transport office.</b></p>
                </Col>
                <Col xs={1} lg={2}></Col>
            </Row>

            <Row>
                <Col xs={1} lg={2}></Col>
                <Col xs={10} lg={8}>
                    <p style={{textAlign : "justify", fontSize : "20px", marginTop : "3%"}}>&emsp;&emsp;<b>📍 How do I know where to pick up my parcel?</b><br></br>
                    &emsp;&emsp;&emsp;&emsp;Once your order is shipped, you will receive a <b>call or SMS</b> with:
                        <div style={{marginLeft : "10%"}}>
                            <ul data-start="806" data-end="884">
                                <li data-start="806" data-end="842">
                                    <p data-start="808" data-end="842">The name of the transport office</p>
                                </li>
                                <li data-start="843" data-end="861">
                                    <p data-start="845" data-end="861">Contact number</p>
                                </li>
                                <li data-start="862" data-end="884">
                                    <p data-start="864" data-end="884">Parcel or order ID</p>
                                </li>
                            </ul>
                        </div>
                    </p>
                </Col>
                <Col xs={1} lg={2}></Col>
            </Row>

            <Row>
                <Col xs={1} lg={2}></Col>
                <Col xs={10} lg={8}>
                    <p style={{textAlign : "justify", fontSize : "20px", marginTop : "3%"}}>&emsp;&emsp;<b>🚚 Which transport services do you use?</b><br></br>
                    &emsp;&emsp;&emsp;&emsp;We work with trusted <b>regional transport providers</b> who specialize in goods logistics across Tamil Nadu and South India.</p>
                </Col>
                <Col xs={1} lg={2}></Col>
            </Row>

            <Row>
                <Col xs={1} lg={2}></Col>
                <Col xs={10} lg={8}>
                    <p style={{textAlign : "justify", fontSize : "20px", marginTop : "3%"}}>&emsp;&emsp;<b>🆔 What do I need to bring to collect my parcel?</b><br></br>
                    &emsp;&emsp;&emsp;&emsp;You must bring:
                    <div style={{marginLeft : "10%"}}>
                            <ul data-start="806" data-end="884">
                                <li data-start="806" data-end="842">
                                    <p data-start="808" data-end="842">The <b>parcel ID or OTP</b> (shared with you via SMS/Email)</p>
                                </li>
                                <li data-start="843" data-end="861">
                                    <p data-start="845" data-end="861">A valid <b>ID proof</b> (for identity verification, if requested by the transport office)</p>
                                </li>
                            </ul>
                        </div>
                    </p>
                </Col>
                <Col xs={1} lg={2}></Col>
            </Row>

            <Row>
                <Col xs={1} lg={2}></Col>
                <Col xs={10} lg={8}>
                    <p style={{textAlign : "justify", fontSize : "20px", marginTop : "3%"}}>&emsp;&emsp;<b>🕒 When will I receive my order?</b><br></br>
                    &emsp;&emsp;&emsp;&emsp;All orders are dispatched within a few days of confirmation. You will receive your order <b>within a maximum of 10 days</b> from the date it was placed.</p>
                </Col>
                <Col xs={1} lg={2}></Col>
            </Row>

            <Row>
                <Col xs={1} lg={2}></Col>
                <Col xs={10} lg={8}>
                    <p style={{textAlign : "justify", fontSize : "20px", marginTop : "3%"}}>&emsp;&emsp;<b>❌ What if I miss the call from the transport office?</b><br></br>
                    &emsp;&emsp;&emsp;&emsp;Don’t worry! If you miss the call, you can still use your <b>order ID and transport details (from email or SMS)</b> to collect the parcel.</p>
                </Col>
                <Col xs={1} lg={2}></Col>
            </Row>

            <Row>
                <Col xs={1} lg={2}></Col>
                <Col xs={10} lg={8}>
                    <p style={{textAlign : "justify", fontSize : "20px", marginTop : "3%"}}>&emsp;&emsp;<b>🧨 What if there is damage or missing items in my parcel?</b><br></br>
                    &emsp;&emsp;&emsp;&emsp;Please reach out to our support team immediately:<br></br>
                    <div style={{marginLeft : "10%"}}>
                        📧 Email: <strong><a href="mailto:support@cracklecart.com" target="_blank">support@cracklecart.com</a></strong><br></br>
                        📸 If possible, include photos of the parcel and items for faster resolution.
                    </div>
                    </p>
                </Col>
                <Col xs={1} lg={2}></Col>
            </Row>


        </>
    );
}

export default Faq;